<h2 mat-dialog-draggable-title mat-dialog-title>{{'approved.add_list_approver' | translate}}
    <button (click)="onNoClick()" aria-label="Close" cdkFocusInitial class="close" type="button">
      <span aria-hidden="true">&times;</span>
    </button>
  </h2>
  <mat-divider></mat-divider>
  <div>
    <form name="form" [formGroup]="addApproverForm" appFocusFirstElement>
      <div formArrayName="approve" style="max-height: 500px; overflow:auto">
          <div *ngFor="let item of approverFormArray.controls; index as i">
              <div class="row card-approver " [formGroupName]="i">
                  <div  class="col-md-6 col-lg-12 p-2 font-weight-bold mb-2" style="border-bottom: 1px solid lightgray;">{{'approved.approver' | translate}} {{i+1}}
                      <i class="fa fa-trash ml-3" *ngIf="approverFormArray.controls.length > 1" (click)="onDeleteApprover(i)" aria-hidden="true" matTooltip="{{ 'tooltips.delete' | translate }}"></i>
                  </div>
                  <mat-divider></mat-divider>
                <div class="col-md-6 col-lg-6" *ngIf=" data.checkAnhKy">
                  <mat-checkbox    color="primary" (change)="changeCTS(i)" formControlName="CTS">
                    {{'enterprise_contract.panel_document.table_users.header.CTS' | translate}}
                  </mat-checkbox>
                </div>
                <div class="col-md-6 col-lg-12" *ngIf=" !data.checkAnhKy">
                  <mat-checkbox    color="primary" (change)="changeCTS(i)" formControlName="CTS">
                    {{'enterprise_contract.panel_document.table_users.header.CTS' | translate}}
                  </mat-checkbox>
                </div>
                <div class="col-md-6 col-lg-6"  *ngIf="approve.controls[i].get('CTS').value && data.checkAnhKy">
                  <mat-checkbox    color="primary" formControlName="showImage">
                    {{'enterprise_contract.panel_document.table_users.header.showImage' | translate}}
                  </mat-checkbox>
                </div>
                <div class="col-md-6 col-lg-6"  *ngIf="!approve.controls[i].get('CTS').value && data.checkAnhKy">
                  <mat-checkbox    color="primary" formControlName="showImage" disabled>
                    {{'enterprise_contract.panel_document.table_users.header.showImage' | translate}}
                  </mat-checkbox>
                </div>
                  <div class="col-md-6 col-lg-6">
                      <mat-form-field class="mat-full-width">
                          <mat-label>{{ "form.full_name" | translate }}</mat-label>
                          <input matInput
                                 formControlName="fullName"
                                 name="fullname" maxlength="255"
                                 id="fullname"
                                 (focusout)="checkFocusOutFullname(i)"
                                 required
                                 type="text"/>
                                 <mat-error *ngIf="approve.controls[i].get('fullName')?.errors?.required">
                                  <span class="text-error">{{'update_enterprise.validation.lbl_validation_representative' | translate}}</span>
                                </mat-error>
                      </mat-form-field>
                  </div>
                <div class="col-md-6 col-lg-6" *ngIf="approve.controls[i].get('CTS').value">
                  <mat-form-field class="mat-full-width">
                    <mat-label>{{ "form.taxCode" | translate }}</mat-label>
                    <input matInput
                           formControlName="taxCode"
                           name="taxCode" maxlength="20"
                           id="taxCode"
                           (focusout)="checkFocusOutTaxCode(i)"
                           required
                           type="text"/>
                    <mat-error *ngIf="approve.controls[i].get('taxCode')?.errors?.required">
                      <span class="text-error">{{'update_enterprise.validation.lbl_validation_cmt' | translate}}</span>
                    </mat-error>
                    <mat-error *ngIf="approve.controls[i].get('taxCode')?.errors?.pattern">
                      <span class="text-error">{{'validation.certificate_no_CMT' | translate}}</span>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-6" *ngIf="!approve.controls[i].get('CTS').value">
                  <mat-form-field class="mat-full-width">
                    <mat-label>{{ "form.taxCode" | translate }}</mat-label>
                    <input matInput
                           id="taxCodeNew" maxlength="20"
                           formControlName="taxCodeNew"
                           (focusout)="checkFocusOutTaxCodeNew(i)"
                           [placeholder]="'placeholder.taxCode' | translate" type="text"/>
                    <mat-error *ngIf="approve.controls[i].get('taxCodeNew')?.errors?.pattern">
                      <span class="text-error">{{'validation.certificate_no_CMT' | translate}}</span>
                    </mat-error>
                  </mat-form-field>
                </div>
                  <div class="col-md-6 col-lg-6">
                      <mat-form-field class="mat-full-width">
                          <mat-label>Email</mat-label>
                          <input matInput
                                 formControlName="email"
                                 name="email" maxlength="200"
                                 id="email"
                                 (focusout)="checkFocusOutEmail(i)"
                                 required
                                 [placeholder]="'placeholder.email' | translate" type="text"/>
                                 <mat-error *ngIf="approve.controls[i].get('email')?.errors?.required">
                                  <span class="text-error">{{'validation.email_phone_required' | translate}}</span>
                                </mat-error>
                                <mat-error *ngIf="approve.controls[i].get('email')?.errors?.pattern">
                                  <span class="text-error">{{'validation.email_format' | translate}}</span>
                                </mat-error>
                                <mat-error *ngIf="approve.controls[i].get('email').errors?.duplicated && !approve.controls[i].get('email').errors?.pattern">
                                  <span class="text-error">{{'approved.email_duplicate' | translate}}</span>
                                </mat-error>
                      </mat-form-field>
                  </div>
                <div class="col-md-6 col-lg-6">
                  <mat-form-field class="mat-full-width">
                    <mat-label>{{ "form.phone" | translate }}</mat-label>
                    <input matInput
                           id="phone"
                           formControlName="phoneNumber"
                           (focusout)="checkFocusOutPhone(i)"
                           [placeholder]="'placeholder.phone' | translate" type="text"/>
                    <mat-error *ngIf="approve.controls[i].get('phoneNumber')?.errors?.pattern">
                      <span class="text-error">{{'approved.validate_phone_pattern' | translate}}</span>
                    </mat-error>
                    <mat-error *ngIf="approve.controls[i].get('phoneNumber')?.errors?.minlength && !approve.controls[i].get('phoneNumber')?.errors?.pattern">
                      <span class="text-error">{{'approved.validate_phone' | translate}}</span>
                    </mat-error>
                    <mat-error *ngIf="approve.controls[i].get('phoneNumber')?.errors?.maxlength && !approve.controls[i].get('phoneNumber')?.errors?.pattern">
                      <span class="text-error">{{'approved.validate_phone' | translate}}</span>
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
          </div>
        </div>
      <button mat-stroked-button color="primary" class="btn ml-1 mt-4" type="button" (click)="onAddAproverClick()">
          <mat-icon class="mr-0">add_circle_outline</mat-icon>
          <span class="font-weight-bold">{{ "button.add_approver" | translate }}</span>
        </button>
    </form>
    <mat-dialog-actions align="center" class="pt-2 pb-3">
      <button mat-stroked-button color="primary" type="button" (click)="onCancel()" class="mr-2">
        <mat-icon class="mr-0">cancel</mat-icon>{{ "button.cancel" | translate }}
      </button>
      <button mat-raised-button color="primary" type="submit" (click)="onSave()" class="ml-2">
        <mat-icon class="mr-0">save</mat-icon>{{ "button.confirm" | translate }}
      </button>
    </mat-dialog-actions>
  </div>
